import { cellBoundsAtom, jotaiStore } from '@/lib/jotai'

export interface ICellBounds {
  x: number
  y: number
  width: number
  height: number
}

export const calculateMarginTop = () => {
  const bounds = jotaiStore.get(cellBoundsAtom)
  let marginTopValue = '0'

  if (bounds) {
    const viewportHeight = window.innerHeight
    if (bounds.y + bounds.height > viewportHeight - 200) {
      marginTopValue = '-140px'
    }
  }

  return marginTopValue
}

export const getCellBounds = () => {
  const bounds = jotaiStore.get(cellBoundsAtom)
  return bounds as ICellBounds
}

export const calculateEditorPosition = (
  bounds: ICellBounds,
  editorHeight: number,
  windowHeight: number
): { top: number; left: number } => {
  const spaceAbove = bounds.y
  const spaceBelow = windowHeight - (bounds.y + bounds.height)

  let top: number

  if (spaceBelow < editorHeight && spaceAbove > spaceBelow) {
    top = bounds.y - editorHeight
  } else {
    top = bounds.y + bounds.height
  }

  top = Math.max(0, Math.min(top, windowHeight - editorHeight))

  return {
    top,
    left: bounds.x,
  }
}
